import { Component, Input, OnInit, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormConfigService, FormHelperService, PermissionService, FamilyService, UserService, SnackbarService } from '@app/services';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { StepType } from '@app/forms/config/form-model';
import { Observable, forkJoin, of } from 'rxjs';
import { FormViewerComponent, SubmitFormEvent } from '@app/components/_public/form-viewer/form-viewer.component';
import { AdresseUpdateService } from '@app/services/adresse-update.service';
import { addressToUpdate } from '@app/models/address';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { FormType } from '@app/models/global-config';


@Component({
  selector: 'app-foyer-edit',
  templateUrl: './foyer-edit.component.html',
  styleUrls: ['./foyer-edit.component.scss'],
  standalone: false
})
export class FoyerEditComponent implements OnInit {

  id: number;
  idUser: number;
  @Input() stepForm: string;
  @Input() fromDemarche: boolean;
  @Input() demarcheTitle: string;
  @Output() onValidate = new EventEmitter<any>();
  readOnly: boolean;

  form: StepType[];
  data: any;
  isLoading = true;
  loadingMessage = 'Chargement';
  typeForm: FormType = 'form-famille';

  formTitle: string;
  form$: Observable<any>;
  dataUpdateAddress: addressToUpdate;
  updateUserChecked: string;
  updateConjointChecked: string;
  conjointData: any;
  userData: any;
  manyAddressesDisplay: boolean;

  @ViewChild(FormViewerComponent) formViewer: FormViewerComponent;
  @ViewChild('updateAddressBottomSheet', { static: true }) updateAddressBottomSheet: TemplateRef<any>;

  constructor(
    private formConfigService: FormConfigService,
    private helperService: FormHelperService,
    private familyService: FamilyService,
    private route: ActivatedRoute,
    private location: Location,
    private permService: PermissionService,
    private userService: UserService,
    private addressUpdateService: AdresseUpdateService,
    private snackbarService: SnackbarService,
    public bottomSheet: MatBottomSheet
  ) { }

  ngOnInit() {
    this.id = (this.familyService.currentFamily ? this.familyService.currentFamily.id : null) || null;
    this.stepForm = this.stepForm ? this.stepForm : this.route.snapshot.paramMap.get('step');
    this.readOnly = this.id && !this.permService.hasPermission('foyer_edit') || !this.familyService.currentFamily.active;
    this.idUser = this.userService.currentUser.id;
    this.familyService.currentFamilyReadyOnce$.subscribe(f => this.formTitle = 'Famille ' + f.nom);
    this.form$ = this.familyService.getFormData(this.id, this.stepForm);

    if (this.fromDemarche) {
      this.formTitle = this.demarcheTitle;
    }

    forkJoin([
      this.form$,
      this.userService.getCurrentFamilyAdults()
    ]).subscribe(([result, adultes]) => {

      if (result.config) {
        this.form = this.formConfigService.getFormView(result.config).filter(f => f.enabled);
      }

      if (result.data && (result.data["debiteurPrincipal"] || result.data["allocataire"])) {
        this.updateResponsablesNamesInRadioLabels(this.form, adultes, result.data);
      }

      this.data = !result.data ? { modeCreation: true } : result.data;

      setTimeout(() => { // doit être encadré dans un setTimeout car sinon le 'formViewer' n'est pas accessible (car il était masqué par 'isLoading')...
        this.formViewer?.handleReturnProgramOnDisplay(result);
      })

      this.isLoading = false;
    }, err => this.snackbarService.error('Une erreur est survenue lors du chargement'));
  }

  updateResponsablesNamesInRadioLabels(form: StepType[], adultes: any[], data) {
    form.forEach(step => {
      if (step.stepName === "complement") {
        const fieldDebiteurPrincipal = this.formConfigService.findFieldByName(step.fields, "debiteurPrincipal");
        const fieldAllocataire = this.formConfigService.findFieldByName(step.fields, "allocataire");
        const resp1 = adultes.find(ad => ad.order === 1);
        const resp2 = adultes.find(ad => ad.order === 2);
        const resp1Label = resp1 ? resp1.nom + ' ' + resp1.prenom : 'Responsable 1';
        const resp2Label = resp2 ? resp2.nom + ' ' + resp2.prenom : 'Responsable 2';

        const updateFieldOptions = (options: any[], dataField: any) => {
          options.forEach(opt => {
            switch (opt.value) {
              case "1": opt.label = resp1Label; break;
              case "2": opt.label = resp2Label; break;
              case "3": opt.label = resp1Label + ' & ' + resp2Label; break;
            }

            if (adultes.length < 2) {
              dataField = (parseInt(dataField, 10) > 1) ? null : dataField;
              options.splice(1);
            }
          })
        }

        if (fieldAllocataire) {
          updateFieldOptions(fieldAllocataire.templateOptions.options as any[], data.allocataire)
        }

        if (fieldDebiteurPrincipal) {
          updateFieldOptions(fieldDebiteurPrincipal.templateOptions.options as any[], data.debiteurPrincipal)
        }
      }
    });
  }

  checkAddress() {
    this.addressUpdateService.checkAddress('famille').subscribe((data: addressToUpdate) => {
      this.dataUpdateAddress = data;

      if ((data.userAddress && !data.userAddressIsSameFamilyAddress) ||
        (data.conjointAddress && !data.conjointAddressIsSameFamilyAddress)) {

        this.userData = this.addressUpdateService.extractDataWithoutAdress(data.user);

        if (this.dataUpdateAddress.conjoint) {
          this.conjointData = this.addressUpdateService.extractDataWithoutAdress(data.conjoint);
        }

        this.bottomSheet.open(this.updateAddressBottomSheet);

        this.manyAddressesDisplay = this.addressUpdateService.manyAddressesDisplay(
          data.conjointAddress,
          data.userAddress,
          data.conjointAddressIsSameFamilyAddress,
          data.userAddressIsSameFamilyAddress)
      }
    });
  }

  validUpdate() {
    if (this.updateUserChecked === 'oui' && (this.updateConjointChecked === 'non' || !this.updateConjointChecked)) {
      this.addressUpdateService.updateAddressUser('foyer', this.dataUpdateAddress);
    }

    if ((this.updateUserChecked === 'non' || !this.updateUserChecked) && this.updateConjointChecked === 'oui') {
      this.addressUpdateService.updateAddressConjoint('foyer', this.dataUpdateAddress);
    }

    if (this.updateUserChecked === 'oui' && this.updateConjointChecked === 'oui') {
      this.addressUpdateService.updateAddresses('foyer', this.dataUpdateAddress);
    }
  }

  onSave(event: SubmitFormEvent) {
    const data = event.model;
    this.formViewer.setErrorMessage('');
    this.loadingMessage = 'Enregistrement';
    if (this.readOnly) {
      return;
    }
    this.isLoading = true;
    const saveMethod = (this.id) ? this.familyService.update(data, this.id, this.stepForm) : this.familyService.create(data);
    saveMethod.subscribe((result: any) => {
      this.helperService.displayDebugTraces(result.traces);
      this.helperService.notifySuccess('Modification effectuée', result.messages);
      if (this.id) {
        if (this.stepForm === "coordinates") {
          this.checkAddress();
        }
      }
      if (!this.fromDemarche) {
        this.location.back();
      } else {
        this.onValidate.emit({
          id: this.id,
          type: 'Famille',
          typeStructure: 'Domino',
        });
        this.isLoading = false;
      }
    }, err => {
      this.isLoading = false;

      setTimeout(() => { // doit être encadré dans un setTimeout car sinon le 'formViewer' n'est pas accessible (car il était masqué par 'isLoading')...
        this.helperService.manageServerError(err, this.formViewer);
      })
    });
  }


  closeBottomSheet(value) {
    if (value) {
      this.bottomSheet.dismiss();
    }
  }
}
